/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-14 09:50:35
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

export default  ({ list = [], color = [] }) => {
  const _data = [...list];
  const _color = [...color];
  _data.reverse();
  _color.reverse();

  return {
    title: {
      text: '安踏 重点媒介渠道覆盖内容数量及内容性质分布',
      left: 80,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color: _color,
    legend: {
      bottom: 20,
      left: 5,
      orient: 'vertical',
    },
    grid: {
      left: 160,
      right: 0,
      bottom: '3%',
      containLabel: false
    },
    xAxis: {
      type: 'category',
      show: false,
      axisLabel: { ...xAxisLabelColor },
      axisLine: { show: false },
      axisTick: { show: false },
      minorTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      axisLabel: { ...yAxisLabelColor },
      splitLine: { show: false },
    },
    series: _data.map(item => ({
      stack: 'same',
      type: 'bar',
      name: item.name,
      data: item.list
    })),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P18/chart.js